var _defs, _g, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBattery100(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #fff;\n        stroke: #62797e;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #00dc92;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.7,
    y: 17.9,
    width: 45,
    height: 74.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.2,7.9h26.1c1,0,1.8.9,1.8,2.1v5.1c0,1.1-.8,2.1-1.8,2.1h-26.1c-1,0-1.8-.9-1.8-2.1v-5.1c0-1.1.8-2.1,1.8-2.1Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 32.7,
    y: 73.6,
    width: 33,
    height: 12.4,
    rx: 1.8,
    ry: 1.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 32.7,
    y: 57.2,
    width: 33,
    height: 12.4,
    rx: 1.8,
    ry: 1.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 32.7,
    y: 40.8,
    width: 33,
    height: 12.4,
    rx: 1.8,
    ry: 1.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 32.7,
    y: 24.4,
    width: 33,
    height: 12.4,
    rx: 1.8,
    ry: 1.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery100);
export default __webpack_public_path__ + "static/media/battery100.d27768c4b1c8e740c5cd98f1d82e388e.svg";
export { ForwardRef as ReactComponent };